import Button from '#/components/Button'
import Categories from '#/containers/Changelog/components/categories'
import CoverImage from '#/containers/News/components/CoverImage'
import { logEvent } from '#/services/analytics'
import styles from '../styles.module.scss'
import { Gallery } from '../types'

export const CardDetails = ({ title, categories }: Gallery.CardDetailsProps) => (
  <div className={styles['th-details-container']}>
    <div className={styles['th-details']}>
      <div className='my-2'>
        <Categories categories={categories} />
      </div>
      {title && (
        <h3
          dangerouslySetInnerHTML={{ __html: title }}
          className={styles['th-title']}
        />
      )}
    </div>
  </div>
)

const GalleryCard: React.FC<Gallery.NewsPreviewProps> = ({
  title,
  categories,
  coverImage,
  date,
  excerpt,
  slug,
  height,
  author
}) => {
  function logCardClick(name: string) {
    logEvent('select_content', {
      content_type: 'gallery',
      item_id: 'open_post',
      value: `${name}`
    })
  }

  return (
    <a
      className={styles['th-gallerycard-container']}
      href={excerpt}
      rel='noreferrer'
      target='_blank'
      onClick={() => logCardClick(slug)}
    >
      <div className={styles['th-gallerycard']}>
        <div className={styles['th-img-wrapper']}>
          <CoverImage
            coverImage={coverImage}
            height={height}
            slug={slug}
            title={title}
          />
        </div>
        <CardDetails author={author} categories={categories} date={date} title={title} />
      </div>

      <div className={styles['th-more-container']}>
        <Button className='rounded-full px-4 py-1.5'>View on TopHap</Button>
      </div>
    </a>
  )
}

export default GalleryCard
